import React, { useMemo } from 'react';
import { toCssDeclarationName } from '@/features/editor/widgets/ai-component/inputs/shared/css-declarations';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { NumberUnitInput } from '@/features/editor/widgets/ai-component/inputs/shared/number-unit-input';

export interface CssNumericInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
}

export function CssNumericInput({
  name,
  initialValue,
  onChange,
}: CssNumericInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);
  const [error, setError] = React.useState<string>(``);

  const onValueChanged = (value: string) => {
    if (onChange) {
      onChange(name, value);
    }
  };

  return (
    <InlineInputCardWrapper className={error ? `error` : ``}>
      <span>{displayName}</span>
      <NumberUnitInput
        noUnit
        step={0.1}
        initialValue={initialValue}
        onChange={onValueChanged}
        onError={setError}
      />
    </InlineInputCardWrapper>
  );
}
